import { type ActionItem } from '../../../common/constants';
import { AiOutlineDelete } from 'react-icons/ai';
import { FaCog } from 'react-icons/fa';
import ListReceiptItem from './ListReceiptItem';
import type { Receipt } from '../../../common/types';

interface IProps {
  items: Receipt[];
  toggleDeleteModal: () => any;
  toggleInfoModal: () => any;
  handleDeletingItem: (item: Receipt) => any;
  handleInfoItem: (item: Receipt) => any;
}

const ListReceipts: React.FC<IProps> = ({
  items: records,
  toggleDeleteModal,
  toggleInfoModal,
  handleDeletingItem,
  handleInfoItem
}) => {
  const deleteItemHandler = (item: Receipt): void => {
    toggleDeleteModal();
    handleDeletingItem(item);
  };

  const infoHandler = (item: Receipt): void => {
    toggleInfoModal();
    handleInfoItem(item);
  };

  const getActionsList = (receipt: Receipt): any[] => {
    const actions: ActionItem[] = [
      {
        type: 'component',
        label: 'View Receipt & Result',
        icon: (
          <button>
            <span className="px-1 h-full">
              <FaCog
                size={18}
                onClick={() => {
                  infoHandler(receipt);
                }}
              />
            </span>
          </button>
        )
      },
      {
        type: 'component',
        label: 'Delete',
        icon: (
          <button
            onClick={() => {
              deleteItemHandler(receipt);
            }}
            className="text-gray-50 text-sm text-center rounded-md"
          >
            <span className="px-1 h-full">
              <AiOutlineDelete color="red" size={18} />
            </span>
          </button>
        )
      }
    ];

    return actions;
  };

  return (
    <>
      <div className="w-full p-2 my-2 overflow-auto rounded-md">
        <table className="w-full p-4 border-b-2 border-gray-200">
          <thead className="bg-gray-100">
            <tr>
              <th className="p-2 pl-8 text-sm font-semibold text-left">ID</th>
              <th className="p-2 pl-8 text-sm font-semibold text-left">Device</th>
              <th className="p-2 text-sm font-semibold text-left">Status</th>
              <th className="p-2 text-sm font-semibold text-left">Date Created</th>
              <th className="p-2 text-sm font-semibold text-left ">ProcessedDate</th>
              <th className="p-2 pr-8 text-sm font-semibold">Actions</th>
            </tr>
          </thead>
          <tbody className="">
            {records.map((record) => {
              return <ListReceiptItem key={record.id} item={record} actions={getActionsList(record)} />;
            })}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default ListReceipts;
